import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import LangingToolBar from "./LangingToolBar";
import FooterSection from "./FooterSection";
import OverviewSection from "./OverviewSection";
import  FeaturesSection  from "./Features";
import EventTypes from "./EventTypes";
import VenueManagerSection from "./VenueManagerSection";

import { ROUTE_MAIN_HOME, SESSION_USER_ID_KEY } from "../../Util/VMConstants";
import StorageFactory from "../../Util/StorageFactory";
import { isEmpty } from "../../Util/UtilHelper";
import { VM_Colors } from "../../Styles/VMStyles";

function VMLandingPage() {
  const navigate = useNavigate();
  const sessionFactory = new StorageFactory("session");
  const sessionUserId = sessionFactory.get(SESSION_USER_ID_KEY);
 

  /* ✅ Redirect logged-in users (replace history) */
  useEffect(() => {
    if (!isEmpty(sessionUserId)) {
      navigate("/" + ROUTE_MAIN_HOME, { replace: true });
    }
  }, [navigate, sessionUserId]);

  /* ✅ REMOVE ALL PREVIOUS ROUTES + DISABLE BACK BUTTON */
  useEffect(() => {
    // Replace current history entry
    window.history.replaceState(null, "", window.location.href);

    const blockBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", blockBack);

    return () => {
      window.removeEventListener("popstate", blockBack);
    };
  }, []);



  return (
    <Box sx={{ width: "100%", overflowX: "hidden" ,backgroundColor:VM_Colors.white1}}>
      <LangingToolBar />
      <OverviewSection />
      <FeaturesSection />
      <EventTypes />
      <VenueManagerSection />
      <FooterSection />
    </Box>
  );
}

export default VMLandingPage;
